import { render, staticRenderFns } from "./BroadcastCrtDraft.vue?vue&type=template&id=56bf36f8&scoped=true&"
import script from "./BroadcastCrtDraft.vue?vue&type=script&lang=js&"
export * from "./BroadcastCrtDraft.vue?vue&type=script&lang=js&"
import style0 from "./BroadcastCrtDraft.vue?vue&type=style&index=0&id=56bf36f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bf36f8",
  null
  
)

export default component.exports